import styled, { css } from "styled-components";
import { rgba } from "polished";
import settings from "../../assets/images/settings.svg";
import settings2 from "../../assets/images/settings2.svg";
import { Icon } from "../SportType/style";

export const HeaderContainer = styled.header`
  align-items: center;
  background: linear-gradient(173deg, ${({ theme }) => theme.colors.color33} 0%, ${({ theme }) => theme.colors.color4} 100%);
  display: flex;
  height: 81px;
  justify-content: space-between;
  padding: 0 20px;
  position: relative;
`;

export const TransparentHeaderContainer = styled(HeaderContainer)`
  ${({ multipleDetail }) => multipleDetail && css`
    height: 75px;
  `};
  background: ${({ colored, theme }) => (colored ? theme.colors.color1 : "transparent")};
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
`;

export const BackIcon = styled.button`
  -webkit-appearance: none;
  background: transparent;
  border: 0;
`;

export const Title = styled.h1`
  font-size: 36px;
  margin: 0 0 0 55px;
`;

export const LeagueIcon = styled(Icon)`
  margin-left: 25px;
  margin-right: 5px;
`;

export const LeagueTitle = styled.h1`
  font-size: 30px;
`;

export const SettingsMenu = styled.div`
  z-index: 120;
`;

export const SettingsIcon = styled.div`
  background-image: url(${({ openSettings }) => (openSettings ? settings2 : settings)});
  cursor: pointer;
  height: 33px;
  margin-left: 31px;
  width: 32px;
`;

export const ToggleSwitchWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-left: 16px;
`;

export const Switch = styled.div`
  cursor: pointer;
  height: 26px;
  width: 100%;
`;

export const SwitchButton = styled.div`
  background: ${({ theme }) => theme.colors.color19};
  display: block;
  height: 1px;
  margin-top: 13px;
  position: relative;
  width: 120px;

  &::before, &::after {
    background: ${({ theme }) => theme.colors.color18};
    border-radius: 50%;
    border: 1px solid ${({ theme }) => theme.colors.color19};
    content: '';
    display: block;
    position: absolute;
  }
;

  &::before {
    height: 18px;
    left: 0;
    top: -8px;
    width: 18px;
  }
;

  &::after {
    height: 26px;
    right: 0;
    top: -13px;
    width: 26px;
  }
;

  ${({ size, theme }) => size === "isSmall" && css`
    &::before {
      background: ${theme.colors.color19};
    }
  ;
  `};

  ${({ size, theme }) => size === "isBig" && css`
    &::after {
      background: ${theme.colors.color19};
    }
  ;
  `};

`;

export const MenuIcons = styled.img``;
export const MenuWrapper = styled.div``;
export const SettingsWrapper = styled.div``;

export const MenuTab = styled.ul`
  align-items: center;
  background-color: ${({ theme }) => rgba(theme.colors.color1, 0.4)};
  border-radius: 10px;
  display: flex;
  height: 63px;
  left: 50%;
  position: absolute;
  top: 10px;
  transform: translateX(-50%);
`;

export const MenuTabItem = styled.li`
  margin: 0 16px;
  min-width: 149px;
  text-align: center;
`;

export const MenuTabButton = styled.button`
  border-bottom: 4px solid ${({ active, theme }) => active ? theme.colors.color15 : "none"};
  color: ${({ theme }) => theme.colors.color15};
  cursor: pointer;
  display: block;
  font-size: 24px;
  font-weight: 700;
  line-height: 58px;
  width: 100%;

  ${({ disabled }) => disabled === true && css`
    opacity: 0.3;
  `};

`;
